<script>
  import { push } from "svelte-spa-router";

  push("/");
</script>
